const { uvPrintingGuide } = require('../src/data/uv-printing-guide')
const { uvPrintingCostGuide } = require('../src/data/uv-printing-cost-guide')
const { siteUrl } = require('../src/utils/siteConfig')
const { laserEngravingFacts } = require('./laser-engraving-facts')

const legacySelector = 'link[rel="canonical"][data-basehost][data-baseprotocol]'
const uvGuidePaths = new Set([
  '/services/custom-trophy/',
  uvPrintingGuide.path,
  uvPrintingCostGuide.path,
  laserEngravingFacts.path,
  laserEngravingFacts.nationalPath,
  laserEngravingFacts.metalPath,
  '/services/laser-engraving/texas/houston/',
  '/services/laser-engraving/california/los-angeles/',
])

// These guides and engraving pages own canonicals through Gatsby Head. Remove only the legacy
// plugin's duplicate, never Gatsby-managed tags or other pages' canonicals.
const filterUVGuideHeadComponents = (pathname, components) => {
  if (!uvGuidePaths.has(pathname)) return components

  return components.filter(
    (component) =>
      !(
        component?.type === 'link' &&
        component.props.rel === 'canonical' &&
        component.props['data-basehost'] &&
        component.props['data-baseprotocol']
      )
  )
}

const removeUVGuideLegacyCanonical = (location, document) => {
  if (!uvGuidePaths.has(location.pathname)) return

  document
    .querySelectorAll(legacySelector)
    .forEach((element) => element.remove())
}

// Client-side navigation does not rerun SSR. Put the original plugin-owned
// element back before leaving these guides so its usual onRouteUpdate behavior
// remains intact everywhere else (including pages without a Head canonical).
const restoreLegacyCanonicalAfterUVGuide = (
  { location, prevLocation },
  document
) => {
  if (
    !uvGuidePaths.has(prevLocation?.pathname) ||
    uvGuidePaths.has(location.pathname) ||
    document.querySelector(legacySelector)
  ) {
    return
  }

  const base = new URL(siteUrl)
  const element = document.createElement('link')
  element.setAttribute('rel', 'canonical')
  element.setAttribute('data-baseprotocol', base.protocol)
  element.setAttribute('data-basehost', base.host)
  element.setAttribute(
    'href',
    `${base.origin}${location.pathname}${location.search || ''}${location.hash || ''}`
  )
  document.head.insertBefore(element, document.head.firstChild)
}

module.exports = {
  filterUVGuideHeadComponents,
  removeUVGuideLegacyCanonical,
  restoreLegacyCanonicalAfterUVGuide,
}
